<template>
  <div class="container-fluid" v-if="existePromotor">
    <div class="row" style="width: 100%; margin: 0px">
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <nav
          class="navbar navbar-expand-lg navbar-dark bg-dark"
          style="height: 200px; display: block; margin: 0px !important"
        ></nav>
      </div>

      <div class="col-12 col-sm-12 col-md-2 col-lg-4 col-xl-4"></div>

      <div class="col-12 col-sm-12 col-md-8 col-lg-4 col-xl-4">
        <div class="card" style="margin-top: -150px">
          <div class="card-body">
            <div class="align-items-center text-center">
              <span class="text-primary">
                <img
                  src="../../src/assets/img/Saludsa/saludsa_logo.png"
                  style="width: 200px; margin-bottom: 10px"
                />
              </span>

              <Skeletor
                v-if="loading"
                :shimmer="true"
                height="50"
                width="100%"
                style="margin-bottom: 10px"
              />
            </div>

            <div class="row" v-if="loading">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Skeletor
                  :shimmer="true"
                  height="20"
                  width="100%"
                  pill
                  style="margin-bottom: 10px"
                />
              </div>

              <div
                class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5"
                style="margin-bottom: 10px"
              >
                <Skeletor
                  :shimmer="true"
                  height="20"
                  width="50%"
                  pill
                  style="margin-bottom: 10px"
                />
                <Skeletor
                  :shimmer="true"
                  height="40"
                  width="100%"
                  style="margin-bottom: 10px"
                />
              </div>

              <div
                class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-7"
                style="margin-bottom: 10px"
              >
                <Skeletor
                  :shimmer="true"
                  height="20"
                  width="50%"
                  pill
                  style="margin-bottom: 10px"
                />
                <Skeletor
                  :shimmer="true"
                  height="40"
                  width="100%"
                  style="margin-bottom: 10px"
                />
              </div>

              <div
                class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                style="margin-bottom: 10px"
              >
                <Skeletor
                  :shimmer="true"
                  height="20"
                  width="50%"
                  pill
                  style="margin-bottom: 10px"
                />
                <Skeletor
                  :shimmer="true"
                  height="40"
                  width="100%"
                  style="margin-bottom: 10px"
                />
              </div>

              <div
                class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                style="margin-bottom: 10px"
              >
                <Skeletor
                  :shimmer="true"
                  height="20"
                  width="50%"
                  pill
                  style="margin-bottom: 10px"
                />
                <Skeletor
                  :shimmer="true"
                  height="40"
                  width="100%"
                  style="margin-bottom: 10px"
                />
              </div>

              <div
                class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                align="center"
              >
                <Skeletor
                  :shimmer="true"
                  height="40"
                  width="100%"
                  style="margin-bottom: 10px"
                />
              </div>
            </div>

            <div v-else-if="bienvenido" align="center">
              <v-lazy-image
                :src="photo"
                class="rounded-circle"
                style="
                  background: white;
                  width: 100px;
                  margin-bottom: 10px;
                  margin-top: 10px;
                "
              />

              <h1
                class="invitacion_txt"
                style="
                  margin-bottom: 20px;
                  font-size: 20px;
                  line-height: 30px;
                  text-align: center;
                "
              >
                ¡Hola! ¿Cómo estás?
                <span
                  style="
                    color: #0c75ba;
                    font-weight: bold;
                    text-transform: capitalize;
                  "
                  >{{ displayName }}
                </span>
                te está invitando a contratar el mejor plan médico con
                <span
                  style="
                    color: #0c75ba;
                    font-weight: bold;
                    text-transform: capitalize;
                  "
                  >Saludsa</span
                >
                la empresa líder de medicina prepagada del Ecuador.
              </h1>

              <h1
                class="invitacion_txt"
                style="margin-bottom: 15px; font-size: 20px; text-align: center"
              >
                ¿Quieres que te contactemos?
              </h1>

              <div class="row">
                <form
                  class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                  @submit.prevent="continuar"
                  align="center"
                >
                  <div class="form-check" style="margin-bottom: 16px">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      name="flexRadioDefault"
                      id="flexRadioDefault1"
                      v-model="termsAccepted"
                    />
                    <label
                      class="form-check-label"
                      for="flexRadioDefault1"
                      style="margin: 0"
                    >
                      He leído la
                      <a href="#" class="text-decoration-underline"
                        >Política de Privacidad</a
                      >
                      y consiento el tratamiento de datos personales*
                    </label>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    style="width: 100%; font-size: 18px"
                    :disabled="!termsAccepted"
                  >
                    Si quiero 😀
                  </button>
                </form>
              </div>
            </div>

            <form-venta
              :key="componentKeyFormVenta"
              v-else
              :promo-code="promoCode"
              :is-dashboard="false"
            />
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-2 col-lg-4 col-xl-4"></div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2"></div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 text-center align-items-center justify-content-xl-between"
        style="color: black !important; margin-top: 15px"
      >
        <hr class="horizontal dark" />

        <a
          target="_blank"
          title="Facebook de Saludsa Refiere y Gana"
          href="https://www.facebook.com/"
        >
          <i class="fab fa-facebook-f redes" aria-hidden="true"></i>
        </a>
        <a
          target="_blank"
          title="Instagram de Saludsa Refiere y Gana"
          href="https://www.instagram.com/"
        >
          <i class="fab fa-instagram redes" aria-hidden="true"></i>
        </a>
        <a
          target="_blank"
          title="Email de Saludsa Refiere y Gana"
          href="mailto:info@planproec.com?Subject=Tengo%20una%20pregunta"
        >
          <i class="fas fa-envelope redes" aria-hidden="true"></i>
        </a>
        <a
          target="_blank"
          title="Tiktok de Saludsa Refiere y Gana"
          href="https://www.tiktok.com/"
        >
          <i class="fa-brands fa-tiktok redes" aria-hidden="true"></i>
        </a>

        <p style="margin-top: 10px; margin-bottom: 0; font-size: 12px">
          <a
            href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FTyCs_RefiereyGana_Saludsa_Ecija_rCEV.pdf?alt=media&token=7adbf25f-5531-49ab-b56a-bd0217206fb7"
            target="_blank"
            >Términos y condiciones</a
          >
          -
          <a
            href="https://www.saludsa.com/wp-content/uploads/2026/02/Poli%CC%81tica-de-privacidad.pdf"
            target="_blank"
            >Política de privacidad</a
          >
          <!-- -
          <a
            href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FAVISO%20LEGAL.pdf?alt=media&token=6626e7a7-e9da-426c-917b-35e9a14b8d5a"
            target="_blank"
            >Aviso legal</a
          >-
          <a
            href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FDISCLAIMER.pdf?alt=media&token=f1449eb5-6bb2-4866-a8ca-4ffd541191cf"
            target="_blank"
            >Disclaimer</a
          > -->
        </p>

        <p style="margin-top: 0px; font-size: 12px; margin-bottom: 10px">
          Copyright &copy; {{ year }}
          <a href="https://www.planproec.com" target="_blank">- PlanPro</a>
        </p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2"></div>

      <!-- <div class="col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12">
        <a class="float" :href="textAyuda" target="_blank">
          <svg
            width="30"
            class="my-float"
            style="margin-top: 14px"
            height="30"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentcolor"
          >
            <path
              d="M13.601 2.326A7.854 7.854.0 007.994.0C3.627.0.068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933.0 003.79.965h.004c4.368.0 7.926-3.558 7.93-7.93A7.898 7.898.0 0013.6 2.326zM7.994 14.521a6.573 6.573.0 01-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251A6.56 6.56.0 011.407 7.922c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56.0 014.66 1.931 6.557 6.557.0 011.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729.0 00-.529.247c-.182.198-.691.677-.691 1.654.0.977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
            />
          </svg>
        </a>
      </div> -->
    </div>
  </div>

  <div v-else class="row" style="width: 100%; margin: 0px">
    <not-promotor />
  </div>
</template>

<script>
/* eslint-disable */

import firebase from "firebase/compat/app";
import "firebase/compat/app-check";
import NotPromotor from "./NotPromotor";
import FormVenta from "./FormVenta";

export default {
  name: "Venta",
  components: {
    FormVenta,
    NotPromotor,
  },
  data() {
    let promoCode = this.$route.params.promoCode;

    return {
      existePromotor: true,
      year: new Date().getFullYear(),
      appCheck: null,
      tokenAuth: null,
      loading: true,
      photo: "",
      promoCode: promoCode,
      componentKeyFormVenta: 0,
      displayName: "",
      bienvenido: true,
      termsAccepted: false,
      textAyuda:
        "https://api.whatsapp.com/send?phone=593979665549&text=Hola,%20deseo%20obtener%20más%20información%20de%20Saludsa%20Refiere%20y%20Gana",
    };
  },
  methods: {
    continuar() {
      this.bienvenido = false;
    },

    getInfo() {
      this.$https
        .post("/links/getUserByCode/", { promoCode: this.promoCode })
        .then(async (response) => {
          if (response.data.code == 200) {
            this.displayName = response.data.datos.displayName
              .trim()
              .toLowerCase();
            if (!response.data.datos.photoURL) {
              this.photo = "/img/user.svg";
            } else {
              this.photo = response.data.datos.photoURL;
            }

            let array = this.displayName.split(" ");
            if (array.length === 1) {
              this.displayName = array[0];
            } else if (array.length === 2) {
              this.displayName = array[1] + " " + array[0];
            } else if (array.length === 3) {
              this.displayName = array[2] + " " + array[0] + " " + array[1];
            } else if (array.length === 4) {
              this.displayName =
                array[2] + " " + array[3] + " " + array[0] + " " + array[1];
            } else {
              this.displayName =
                array[2] + " " + array[3] + " " + array[0] + " " + array[1];
            }

            document.title = "Saludsa - Medicina prepagada del Ecuador";

            this.loading = false;

            this.bienvenido = true;
          } else {
            if (response.data.code == 404) {
              this.$toast.error(response.data.message, {
                position: "top-right",
                max: 10,
              });

              this.existePromotor = false;
            } else {
              /* this.getInfo(); */
            }
          }
        })
        .catch((error) => {
          /* this.getInfo(); */
        });
    },
  },
  computed: {},
  watch: {},
  mounted() {
    document.title = "Saludsa - Medicina prepagada del Ecuador";
    this.getInfo();

    this.$eventBus.on("reiniciarFormVenta", () => {
      this.componentKeyFormVenta += 1;
    });
  },
  created() {},
  beforeUnmount() {},
};
</script>

<style scoped>
.container-fluid {
  padding: 0px;
  margin: 0px;
}

.bg-dark {
  background: linear-gradient(87deg, #08629e, #0c75ba) !important;
  height: 160px;
}
</style>
